<template>
  <div>
    <q-dialog :visible="isVisible" :title="title" width="1200px" :innerScroll="false" :showFooter="false" @close="onCancel">
      <div class="content">
        <!-- 搜索区域 -->
        <dialog-search-box class="search-area">
          <el-form :inline="true" :model="searchForm" label-width="80px" size="mini" ref="searchForm">
            <el-form-item label="类型" prop="adjustType">
              <el-select v-model="searchForm.adjustType" placeholder="请选择调整类型" clearable>
                <el-option label="修改" value="修改"></el-option>
                <el-option label="删除" value="删除"></el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="文件名" prop="folderName">
              <el-input v-model="searchForm.folderName" placeholder="请输入文件夹进行搜索" clearable></el-input>
            </el-form-item>
            <el-form-item label="修改人" prop="updateUser">
              <el-input v-model="searchForm.updateUser" placeholder="请输入修改人进行搜索" clearable></el-input>
            </el-form-item>
            <el-form-item label="调整时间">
              <form-date-range
                :form="searchForm"
                startKey="dts"
                endKey="dte"
                valueFormat="yyyy-MM-dd"
                :usingTime="false"
              />
            </el-form-item>
          </el-form>
          <template v-slot:right>
            <el-button type="primary" class="green-btn" size="mini" @click="onSearch">搜索</el-button>
            <el-button class="orange-btn" size="mini" @click="onReset">重置</el-button>
          </template>
        </dialog-search-box>
        <!-- 表格 -->
        <el-table :data="tableData.list" border :height="380" style="width: 100%" v-loading="loading"
          :header-cell-style="{ backgroundColor: '#F4F8FB', textAlign: 'center' }"
          :cell-style="{ textAlign: 'center' }">
          <el-table-column prop="adjustType" label="调整类型" width="100" show-overflow-tooltip></el-table-column>
          <el-table-column prop="folderName" label="文件夹名称" min-width="140" show-overflow-tooltip></el-table-column>
          <el-table-column prop="folderPath" label="文件路径" min-width="180" show-overflow-tooltip></el-table-column>
          <el-table-column prop="isNotice" label="是否通知" width="80" show-overflow-tooltip>
            <!-- <template slot-scope="scope">
              {{ scope.row.isNotify === 1 ? '是' : '否' }}
            </template> -->
          </el-table-column>
          <el-table-column prop="noticeTime" label="通知时间" width="140" show-overflow-tooltip></el-table-column>
          <el-table-column prop="creationDate" label="调整时间" width="140" show-overflow-tooltip></el-table-column>
          <el-table-column prop="userName" label="修改人" width="100" show-overflow-tooltip></el-table-column>
        </el-table>
        <!-- 分页 -->
        <div height="auto" style="text-align: right; padding-top: 10px">
          <el-pagination
            @size-change="handleSizeChange"
            @current-change="handleCurrentChange"
            :current-page="tableData.pageNum"
            :page-sizes="[30, 50, 100]"
            :page-size="tableData.pageSize"
            layout="total, sizes, prev, pager, next, jumper"
            background
            :total="tableData.total"
          ></el-pagination>
        </div>
      </div>
    </q-dialog>
  </div>
</template>

<script>
import DialogSearchBox from "@/components/dialog-search-box/dialog-search-box.vue";
import FormDateRange from "@/components/form-date-range/form-date-range.vue";

export default {
  name: "uploadRecords",
  components: {
    DialogSearchBox,
    FormDateRange,
  },
  props: {
    // 重新对外暴露visible，控制显示隐藏
    visible: {
      type: Boolean,
      default: false,
    },
    foldId: [String, Number],
  },
  computed: {
    // 通过计算属性，对.sync进行转换，外部也可以直接使用visible.sync
    isVisible: {
      get() {
        return this.visible;
      },
      set(val) {
        this.$emit("update:visible", val);
      },
    },
    title() {
      return "调整记录";
    },
  },
  data() {
    return {
      loading: false,
      searchForm: {
        adjustType: '',
        folderName: '',
        updateUser: '',
        dts: '',
        dte: '',
      },
      tableData: {
        list: [],
        pageNum: 1,
        pageSize: 30,
        total: 0,
      },
    };
  },
  methods: {
    init() {
      this.loading = true;
      let data = { 
        pageNum: this.tableData.pageNum,
        pageSize: this.tableData.pageSize,
        filterData: this.searchForm,
      };
      this.$q.newProduct.fullWidthUploadAdjustPage({data: data})
        .then((res) => {
          if (res.code == 200) {
            this.tableData = res.data;
          }
        })
        .finally(() => {
          this.loading = false;
        });
    },
    onSearch() {
      this.tableData.pageNum = 1;
      this.init();
    },
    onReset() {
      this.$refs.searchForm.resetFields();
      this.tableData.pageNum = 1;
      this.init();
    },
    onCancel() {
      this.isVisible = false;
    },
    // 分页器 pagesize
    handleSizeChange(val) {
      this.tableData.pageSize = val;
      this.tableData.pageNum = 1;
      this.init();
    },
    // 分页器 pageNum
    handleCurrentChange(val) {
      this.tableData.pageNum = val;
      this.init();
    },
  },
  created() {
    this.init();
  },
};
</script>

<style lang="stylus" scoped>
.content
  padding 10px

.search-area
  /* 表单控件宽度设置 */
  >>> .el-select,
  >>> .el-input
    width 200px
</style>
